import React from 'react';
import PropTypes from 'prop-types';
import { Card, Icon, Table } from 'semantic-ui-react';
import moment from 'moment';

import CampaignTypeLabel from '../campaign-type-label';
import Hashtags from '../hashtags';

const formatDate = date => moment(date).format('DD/MM/Y');
const getFriendlyDate = date => moment(date).format('Do MMM');

const InfluencerCampaignCard = ({
  campaign: {
    id,
    name,
    campaignType,
    hashtags,
    liveDate,
    endDate,
    createdBy,
    createdDate,
    owner,
  },
  onClick,
}) => (
  <Card onClick={() => onClick(id)} color="green">
    <Card.Content>
      <Card.Header>{name}</Card.Header>
      <Card.Meta>{owner.name}</Card.Meta>
    </Card.Content>
    <Card.Content>
      <Table basic="very">
        <tbody>
          <Table.Row>
            <Table.Cell textAlign="right">
              <Icon name="circle outline" size="small" />
            </Table.Cell>
            <Table.Cell>campaign type</Table.Cell>
            <Table.Cell>
              <CampaignTypeLabel campaignType={campaignType} />
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell textAlign="right">
              <Icon name="tags" size="small" />
            </Table.Cell>
            <Table.Cell>hashtags</Table.Cell>
            <Table.Cell><Hashtags value={hashtags} /></Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell textAlign="right">
              <Icon name="calendar" size="small" />
            </Table.Cell>
            <Table.Cell>posted between</Table.Cell>
            <Table.Cell>
              { formatDate(liveDate) } to { formatDate(endDate) }
            </Table.Cell>
          </Table.Row>
        </tbody>
      </Table>
    </Card.Content>
    <Card.Content extra>
      <Icon name="user" />
      Created by {createdBy} on {(getFriendlyDate(createdDate))}
    </Card.Content>
  </Card>
);

InfluencerCampaignCard.propTypes = {
  campaign: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default InfluencerCampaignCard;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-campaign-card/index.js
 **/